import React from 'react';

const CustomContext = React.createContext();

// custom context for create event
export function useCustomCreateEventContext() {
    return React.useContext(CustomContext);
}

export default CustomContext;